import { Typography } from "@mui/material";
import { theme } from "../../../Common/UI/styles/theme";

export default function ReleaseTwoPointSeven() {
  return (
    <>
      <Typography variant="h6" className="release-title" color={theme.palette.error.main}>
        RELEASE 2.7 – April 22, 2026
      </Typography>
      <ul>
        <li>
          Removed the Product Catalog menu.
        </li>
        <li>
          Restaurant Systems
          <ul>
            <li style={{ listStyleType: "circle" }}>
              Renamed the Store Configuration menu to Restaurant Systems.
            </li>
            <li style={{ listStyleType: "circle" }}>
              Added new monitoring tabs for Menu Items and STS Connectivity.
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
}
